import { UserGroupsDropdownInput } from "#src/batteries-included-components/Dropdowns/UserGroupsDropdownInput";
import { UsersDropdownInput } from "#src/batteries-included-components/Dropdowns/UsersDropdownInput";
import { useWorkflowGraphState } from "#src/batteries-included-components/Graph/WorkflowGraph/WorkflowGraphCanvas/WorkflowGraphStore";
import {
  Form,
  useForm,
  VariableTextInput,
} from "@validereinc/common-components";
import classNames from "classnames/bind";
import React, { useEffect } from "react";
import {
  SendNotificationFormValuesType,
  useWorkflowConfigurationFormStore,
} from "../WorkflowConfigurationFormStore";
import styles from "./WorkflowConfigurationSendNotificationDetails.module.scss";

const cx = classNames.bind(styles);

const WorkflowConfigurationSendNotificationDetails = ({
  stepId,
}: {
  stepId: string;
}) => {
  const {
    setSendNotification,
    setSendNotificationIsValid,
    getSendNotificationFormValues,
  } = useWorkflowConfigurationFormStore();
  const { getAvailableStepVariables } = useWorkflowGraphState();
  const storeValues = getSendNotificationFormValues();
  const workflowVariables = getAvailableStepVariables(stepId ?? "");

  const form = useForm<SendNotificationFormValuesType>({
    values: storeValues,
  });
  const formValues = form.watch();

  const handleValueChange = (
    key: "title" | "message" | "users" | "groups",
    value: unknown
  ) => {
    if (storeValues) {
      setSendNotification({
        ...storeValues,
        [key]: value,
      });
    }
  };

  useEffect(() => {
    setSendNotificationIsValid(form.formState.isValid);
  }, [form.formState.isValid, setSendNotificationIsValid]);

  return (
    <Form
      className={cx("form")}
      {...form}
    >
      <div className={cx("section")}>
        <p className={cx("section-title")}>Content</p>
        <VariableTextInput
          name="title"
          label="Subject"
          isRequired
          suggestions={workflowVariables}
          type="text"
          onChange={(value: string) => handleValueChange("title", value)}
        />
        <VariableTextInput
          name="message"
          label="Body"
          isRequired
          suggestions={workflowVariables}
          type="textarea"
          onChange={(value: string) => handleValueChange("message", value)}
        />
      </div>
      <div className={cx("section")}>
        <p className={cx("section-title")}>Recipients</p>
        <UsersDropdownInput
          name="users"
          label="Users"
          placeholder="Select one or more users..."
          isFluid
          isMulti
          isRequired={!formValues.groups?.length && !formValues.users?.length}
          onChange={(value) => handleValueChange("users", value)}
        />
        <UserGroupsDropdownInput
          name="groups"
          label="Groups"
          placeholder="Select one or more groups..."
          isFluid
          isMulti
          isRequired={!formValues.groups?.length && !formValues.users?.length}
          onChange={(value) => handleValueChange("groups", value)}
        />
      </div>
    </Form>
  );
};

export default WorkflowConfigurationSendNotificationDetails;
